import React, { useState, useEffect } from 'react';
import SideNavbar from "../components/SideNavbar"
import MobileNav from "../components/MobileNav"
import { Outlet } from "react-router-dom"
import { useAuthContext } from "../hooks/useAuthContext"
import logo from '../images/FullLogo_Transparent_NoBuffer.png';

const MainApp = () => {
    //get screensize
    const getScreenSize = () => {
        const width = window.innerWidth;
        if (width <= 1050) return 'small';
        return 'large';
    };

    const [screenSize, setScreenSize] = useState(getScreenSize());

    useEffect(() => {
      const handleResize = () => {
        setScreenSize(getScreenSize());
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);


    return (
        <div className="main-app">
            {screenSize === 'large' ? <SideNavbar /> : <MobileHeader />}
            <div className="pages">
                {screenSize === 'large' && <Header />}
                <Outlet />
            </div>
            {screenSize === 'small' && <MobileNav />}
        </div>
    )
}



const Header = () => {
    const {user} = useAuthContext();
    return (
        <div className="main-app-header">
            <p>{user.email}</p>
        </div>
    )
}

const MobileHeader = () => {

    return (
        <div className="mobile-header">
            <img src={logo} alt="Watcher Logo" width={200}/>
        </div>
    )
}

export default MainApp;